(function() {
    'use strict';
    angular
        .module('bhsApp')
        .factory('ParamTableau', ParamTableau);

    ParamTableau.$inject = ['$resource'];

    function ParamTableau ($resource) {
        var resourceUrl =  'api/param-tableaus/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
